// extracted by mini-css-extract-plugin
module.exports = {"text":"headlineSkins-xxlargeOnWide-text-6b9d67fb"};